module.exports = __webpack_public_path__ + "static/img/jigou-heilongjiang-bottom.4b0b227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-heilongjiang-bottom.png
// module id = 6KXq
// module chunks = 2